module.exports = __webpack_public_path__ + "static/media/pin_blue_icon.82a06440.svg";